var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      [
        _c("ul", { staticClass: "menu-list" }, [
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: _vm.companyRoutes.CompanyMenuVersionAccess.name,
                      params: {},
                      query: "",
                    },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [_c("span", [_vm._v(" V2 Menu Access ")])]
              ),
            ],
            1
          ),
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: _vm.companyRoutes.CompanyEnableNewMenu.name,
                      params: {},
                      query: "",
                    },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [_c("span", [_vm._v(" New Menu Access ")])]
              ),
            ],
            1
          ),
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: _vm.companyRoutes.CompanyUpdateUserAccess.name,
                      params: {},
                      query: "",
                    },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [_c("span", [_vm._v(" Xero Export Access ")])]
              ),
            ],
            1
          ),
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: _vm.companyRoutes.CompanyEmailRouteManage.name,
                      params: {},
                      query: "",
                    },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [_c("span", [_vm._v(" Email Route Manage ")])]
              ),
            ],
            1
          ),
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: _vm.companyRoutes.CompanySetting.name,
                      params: {},
                      query: "",
                    },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [_c("span", [_vm._v(" Company Setting ")])]
              ),
            ],
            1
          ),
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: _vm.companyRoutes.NewFeaturesControl.name,
                      params: {},
                      query: "",
                    },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [_c("span", [_vm._v(" New Features ")])]
              ),
            ],
            1
          ),
          _vm.isRepxEnabled
            ? _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: _vm.companyRoutes.CompanyBusinessHours.name,
                          params: {},
                          query: "",
                        },
                        "active-class": "is-active",
                        exact: "",
                      },
                    },
                    [
                      _c("span", { staticClass: "has-badge-child-offset3" }, [
                        _vm._v(" Business Hours "),
                      ]),
                      _c("span", {
                        staticClass:
                          "has-badge-rounded has-badge-medium has-badge-danger",
                        attrs: { "data-badge": "NEW" },
                      }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: _vm.companyRoutes.SubJobStageSetup.name,
                      params: {},
                      query: "",
                    },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [
                  _c("span", { staticClass: "has-badge-child-offset3" }, [
                    _vm._v(" Sub Job Stage "),
                  ]),
                  _c("span", {
                    staticClass:
                      "has-badge-rounded has-badge-medium has-badge-danger",
                    attrs: { "data-badge": "NEW" },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm.isRepxEnabled
            ? _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: _vm.companyRoutes.CompanyRepxStagesMappingSetup
                            .name,
                          params: {},
                          query: "",
                        },
                        "active-class": "is-active",
                        exact: "",
                      },
                    },
                    [
                      _c("span", { staticClass: "has-badge-child-offset3" }, [
                        _vm._v(" RepX Stages Setup "),
                      ]),
                      _c("span", {
                        staticClass:
                          "has-badge-rounded has-badge-medium has-badge-danger",
                        attrs: { "data-badge": "NEW" },
                      }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: _vm.companyRoutes.CompanyORMUtilities.name,
                      params: {},
                      query: "",
                    },
                    "active-class": "is-active",
                    exact: "",
                  },
                },
                [_c("span", [_vm._v(" ORM Utilities ")])]
              ),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }